import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { Icon, ButtonIcon } from '@saviynt/design-system';

import styles from './SidePanel.module.css';

function SidePanel({ isOpen, footer, onClose, layout, header, className, dataTestId }) {
  const classes = classnames(styles.SidePanel, className);

  return (
    <>
      {isOpen && (
        <div id="SidePanel" className={classes} data-testid={dataTestId}>
          <div className={styles.SidePanelHeader}>
            <div className="SidePanel-header-text">
              <h4 className={styles.SidePanelHeaderTitle}>{header.title}</h4>
              <div className="SidePanel-header-description">{header.description}</div>
            </div>
            <ButtonIcon size="medium" kind="ghost" icon={<Icon kind="Close" />} onClick={onClose} />
          </div>
          <div className={styles.SidePanelContent}>{layout}</div>
          {footer}
        </div>
      )}
    </>
  );
}

SidePanel.propTypes = {
  isOpen: PropTypes.bool,
  layout: PropTypes.element,
  footer: PropTypes.node,
  onClose: PropTypes.func,
  header: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
  }),
  className: PropTypes.string,
  dataTestId: PropTypes.string,
};

SidePanel.defaultProps = {
  isOpen: false,
  layout: null,
  footer: null,
  onClose: () => {},
  header: null,
  className: null,
  dataTestId: null,
};

export default SidePanel;
